<template>
  <div>
    <v-sheet height="64">
      <v-toolbar flat>
        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
          {{ $t("calendar.today") }}
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="prev">
          <v-icon small>
            {{ $t("calendar.previous") }}
          </v-icon>
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="next">
          <v-icon small>
            {{ $t("calendar.next") }}
          </v-icon>
        </v-btn>
        <v-toolbar-title v-if="$refs.calendar">
          {{ $refs.calendar.title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
              <span>{{ $t("calendar." + typeToLabel[type]) }}</span>
              <v-icon right>
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              @click="type = calType"
              v-for="calType in typeToLabel"
              :key="calType"
            >
              <v-list-item-title>{{
                $t("calendar." + calType)
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-sheet>
    <v-sheet height="600">
      <v-calendar
        ref="calendar"
        v-model="focus"
        color="primary"
        :events="events"
        :event-color="getEventColor"
        :type="type"
        @click:event="showEvent"
        @mouseenter:event="hoverEvent"
        @click:more="viewDay"
        @click:date="viewDay"
        v-on:change="updateRange"
        :event-text-color="updateEventTextColor"
        show-week
        :event-more-text="$t('calendar.' + moreText)"
        :locale="locale"
        :weekdays="startDay"
      ></v-calendar>
      <v-menu
        v-model="selectedOpen"
        :close-on-content-click="false"
        :activator="selectedElement"
        offset-x
      >
        <v-card color="grey lighten-4" min-width="350px" flat>
          <v-toolbar :color="selectedEvent.color" dark>
            <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon v-on:click="selectedOpen = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>
      </v-menu>
    </v-sheet>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "Calendar",
  props: {
    events: {
      type: Array,
      default: () => [],
      required: false,
    },
    reset: {
      type: Boolean,
      default: false,
      required: false,
    },
    hoverEffect: {
      type: Boolean,
      default: true,
      required: false,
    },
    type: {
      type: String,
      default: "month",
      required: false,
    },
    locale: {
      type: String,
      default: "en",
      required: false,
    },
  },
  data: () => ({
    focus: "",
    typeToLabel: {
      day: "day",
      week: "week",
      month: "month",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    moreText: "more",
  }),
  mounted() {
    this.$refs.calendar.checkChange();
    window.addEventListener("localstorageChange", (event) => {
      this.locale = event.detail.storage.lang;
    });
  },
  methods: {
    updateEventTextColor(e) {
      if (e.color === "#838e9e") return "#fff";
      else if (e.color === "primary") return "#fff";
      else return "#000";
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      this.$emit("event-selected", event);
    },
    hoverEvent({ nativeEvent, event }) {
      if (!this.hoverEffect) return;
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      this.$emit("update-range", { start, end, type: this.type });
    },
  },
  computed: {
    /**
     * Get days array for calendar component to always start the week as the same day
     * @returns number[]
     */
    startDay() {
      const days = [0, 1, 2, 3, 4, 5, 6];
      const currentDayOfWeek = new Date().getDay();
      const weekDays = [];

      for (let i = currentDayOfWeek; i < days.length; i++) {
        if (weekDays.length === 7) break;
        weekDays.push(i);
        if (i === days.length - 1) i = -1;
      }

      return weekDays;
    },
  },
  watch: {
    reset(newVal) {
      if (!newVal) {
        this.type = "month";
        this.setToday();
        this.$emit("update-range", {});
      }
    },
  },
};
</script>
